
import request from '@/utils/request';

import requestexpot from "@/utils/requestexpot";



// 对外暴露登录接口函数
export function GetPowerPlanBasicInfo(data) {
  return request({
    url: '/Dashbord/Dashboard/GetPowerPlanBasicInfo',
    method: 'get',
    params: data
  });
}

// 对外暴露登录接口函数
export function GetDispGroupGen() {
  return request({
    url: '/Dashbord/Dashboard/GetDispGroupGen',
    method: 'get',
  });
}

// 对外暴露登录接口函数
export function GetVoipPageByGenID(data) {
  return request({
    url: '/Dashbord/Dashboard/GetVoipPageByGenID',
    method: 'post',
    data
  });
}
// 分页查询风机
export function GetAerogeneratorPage(data) {
  return request({
    url: '/Dashbord/Dashboard/GetAerogeneratorPage',
    method: 'post',
    data
  });
}


// 对外暴露登录接口函数
export function GetAerogeneratorGroupPage(data) {
  return request({
    url: '/Dashbord/Dashboard/GetAerogeneratorGroupPage',
    method: 'post',
    data
  });
}

// 分页查询风机
export function GetWeather() {
  return request({
    url: '/Dashbord/Dashboard/GetWeather',
    method: 'post'
  });
}
// 分页查询风机
export function GetGroupGen() {
  return request({
    url: '/Dashbord/Dashboard/GetGroupGen',
    method: 'get',
  });
}



// 消警
export function ReadedAlert(data) {
  return request({
    url: '/Dashbord/AlertMsg/ReadedAlert',
    method: 'get',
    params: data
  });
}

// 获取报警列表
export function AlertGetPage(data) {
  return request({
    url: '/Dashbord/AlertMsg/GetPage',
    method: 'post',
    data
  });
}


// 获取报警列表
export function GetSevenDaysData(data) {
  return request({
    url: '/Dashbord/AlertMsg/GetSevenDaysData',
    method: 'post',
    data
  });
}


// 获取报警列表
export function HandleAlert(data) {
  return request({
    url: '/Dashbord/AlertMsg/HandleAlert',
    method: 'post',
    data
  });
}

// 消警
export function GetDetail(data) {
  return request({
    url: '/Dashbord/AlertMsg/GetDetail',
    method: 'get',
    params: data
  });
}

// 消警
export function clearanceGetPage(data) {
  return request({
    url: "/Dashbord/Clearance/GetPage",
    method: "post",
    data,
  });
}

// 消警
export function ListExport(data) {
  return requestexpot({
    url: "/Dashbord/Clearance/Export",
    method: "post",
    data,
  });
}

export function rotorBladeInferenceGetpage(data) {
  return request({
    url: "/Dashbord/RotorBladeInference/getpage",
    method: "get",
    params: data
  });
}

export function boltGetPage(data) {
  return request({
    url: "/Dashbord/Bolt/getPage",
    method: "get",
    params: data
  });
}

export function audioDetectionPage(data) {
  return request({
    url: "/Dashbord/AudioDetection/getpage",
    method: "get",
    params: data
  });
}

export function GetAllCameras() {
  return request({
    url: "/Dashbord/WindSafety/getAllCameras",
    method: "get",
  });
}

export function GetCameraPlayUrlByType(aeid, type) {
  return request({
    url: `/Dashbord/Dashboard/GetCameraPlayUrlByType?aerogeneratorid=${aeid}&cameratype=${type}`,
    method: "get",
  });
}

export function HKCameraControl(data) {
  return request({
    url: `/Dashbord/Camera/CameraControl`,
    method: "post",
    data
  });
}

// 获取净空设备播放地址
export function GetClearanceDevicePlayUrl(aerogeneratorId) {
  return request({
    url: `/Dashbord/Dashboard/GetClearanceDevicePlayUrl?aerogeneratorId=${aerogeneratorId}`,
    method: "get",
  })
}

// 获取净空报警记录
export function GetAlertRecords(aerogeneratoId, count = 5) {
  return request({
    url: '/Dashbord/Clearance/GetAlertRecords',
    method: 'get',
    params: {
      aerogeneratoId,
      count
    }
  });
}

// 获取近五天报警统计数据
export function GetAlertStatsForLastFiveDays(data) {
  return request({
    url: '/Dashbord/Clearance/GetAlertStatsForLastFiveDays',
    method: 'get'
  });
}
